export default "__VITE_ASSET__BTdxuwoj__"